import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Check, ArrowUpRight, Sparkles } from "lucide-react";
import { APPLY_URL, BENEFITS } from "../../lib/site-data";
import SectionLabel from "./SectionLabel";
import { PriceReveal } from "./PriceReveal";

export default function Membership() {
  return (
    <section
      id="membership"
      data-testid="membership-section"
      className="section-pad bg-[#F9FAFB] text-black relative overflow-hidden"
    >
      <div className="container-x relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5"
          >
            <SectionLabel>Membership</SectionLabel>
            <h2
              data-testid="membership-headline"
              className="font-display mt-8 text-xl md:text-2xl font-bold tracking-tightest leading-[1.05]"
            >
              The right network is built intentionally.
            </h2>
            <div className="mt-6 space-y-4 max-w-md">
              <p className="text-base md:text-lg text-black/70 leading-relaxed" data-testid="membership-p1">
                High Five Access is built for professionals who value
                meaningful, relevant connections over a random crowd.
              </p>
              <p className="text-base md:text-lg text-black/70 leading-relaxed" data-testid="membership-p2">
                Every application is reviewed to help build a curated community
                of people who are here to connect, contribute, and grow through
                meaningful professional relationships.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
            className="lg:col-span-7"
          >
            <div
              data-testid="pricing-card"
              className="relative rounded-3xl border border-white/10 bg-[#0A0A0A] text-white p-8 md:p-12 overflow-hidden"
            >
              <div className="absolute -top-12 -right-12 w-56 h-56 rounded-full bg-orange-600/20 blur-3xl pointer-events-none max-sm:will-change-transform max-sm:[transform:translateZ(0)]" />

              <div className="flex items-center gap-2 text-orange-500 text-[14px] md:text-[15px] uppercase tracking-[0.22em] font-semibold">
                <Sparkles className="w-4 h-4" />
                Annual Membership
              </div>

              <div className="mt-6">
                <PriceReveal variant="card" testid="pricing" />
              </div>
              <p className="mt-3 text-[13px] md:text-sm text-white/60">
                Valid for 12 months from the date of joining.
              </p>

              <div className="hairline-dark my-8" />

              <ul className="space-y-3.5">
                {BENEFITS.map((b, i) => (
                  <li
                    key={b}
                    data-testid={`benefit-${i}`}
                    className="flex items-start gap-3 text-[15px] text-white/85 leading-relaxed"
                  >
                    <span className="shrink-0 mt-0.5 w-5 h-5 rounded-full bg-orange-600/20 text-orange-500 flex items-center justify-center">
                      <Check className="w-3 h-3" strokeWidth={3} />
                    </span>
                    {b}
                  </li>
                ))}
              </ul>

              <p className="mt-6 text-xs text-white/85 leading-relaxed">
                Participation fees for offline networking meetups may vary
                depending on the format and venue.
              </p>

              <Link
                to={APPLY_URL}
                data-testid="membership-apply-button"
                className="btn-primary mt-8 w-full"
              >
                Become a Member
                <ArrowUpRight className="w-4 h-4" />
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
